export default "__VITE_ASSET__CsBa9rEp__"